<form [formGroup]="form" autocomplete="off" (ngSubmit)="saveViewerTemplate()">
  <div class="media-category-names-popup">
    <div class="modal-header">
      <div class="row justify-content-between align-items-center w-100 g-0">
        <div class="col-auto">
          <h4 class="modal-title" id="modal-basic-title">
            {{ data?.template?.name }}
            <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h4>
        </div>
    
        <div class="col-auto">
          <button type="button" class="btn btn-secondary me-2" (click)="modal.dismiss('Cross click')">
            <i class="fa fa-times"></i> Cancel
          </button>
          <button type="submit" class="btn btn-primary btn-primary-color" [disabled]="!form.dirty || form.invalid">
            <i class="fa fa-save"></i> Save
          </button>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 sticky">
          <div class="row">
            <div class="col-auto">
              <label>Template Name</label>
              <input formControlName="name" class="form-control" placeholder="Template Name" [ngClass]="{
                  'border border-danger':
                    form.controls['name'].errors &&
                    form.controls['name'].invalid &&
                    (form.controls['name'].dirty ||
                      form.controls['name'].touched)
                }" />
            </div>
            <div class="col-5">
              <label>Description</label>
              <input formControlName="description" class="form-control" placeholder="Description" />
            </div>
            <div class="col-auto mt-4">
              <mat-checkbox class="me-1" formControlName="isDefault">
                <mat-label class="me-2">Set as Default</mat-label>
              </mat-checkbox>
            </div>

          </div>
        </div>
        <div class="col-12">
          <div class="media-category-result">
            <div class="container-fluid">
              <div class="bg-white mt-4">
                <div class="row">
                  <div class="col-auto">
                    <h5 class="ps-2">
                      Media Categories
                      <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
                    </h5>
                  </div>
                  <!--<div class="col">
                    <button class="btn btn-primary float-end" (click)="openMediaCategoryPopup(null)"><i class="fa fa-plus"></i> Add</button>
                  </div>-->
                </div>
                <!--<div class="table-scroll table-responsive data-grid mt-1" #table>-->
                <div class="table data-grid mt-1" #table>
                  <table mat-table [dataSource]="dataSource" cdkDropList #table1 cdkDragBoundary=".data-grid"
                    [cdkDropListData]="dataSource.data" (cdkDropListDropped)="drop($event)" id="table1"
                    class="table table-hover" matSort infiniteScroll [infiniteScrollDistance]="1"
                    [infiniteScrollThrottle]="100" [infiniteScrollContainer]="table" [fromRoot]="true"
                    (scrolled)="onTableScroll()">
                    <!-- Position Column -->


                    <ng-container matColumnDef="drag">
                      <th mat-header-cell class="category-heading w-3-rem" *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
                        <span class="dragCursor">
                          <i class="fa fa-arrows-alt text-primary"></i>
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="mediaCategoryName">
                      <th mat-header-cell (click)="sortTable('name')" class="category-heading w-6-rem"
                        *matHeaderCellDef>
                        Category Name<i class="fa fa-sort ms-1"></i>
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
                        {{ element.name }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="mediaGroup">
                      <th mat-header-cell (click)="sortTable('mediaGroupName')" class="media-group-heading w-6-rem"
                        *matHeaderCellDef>
                        Group<i class="fa fa-sort ms-1"></i>
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
                        {{ element.mediaGroupName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="leftOrRight">
                      <th mat-header-cell (click)="sortTable('leftOrRight')" class="media-side-heading w-3-rem"
                        *matHeaderCellDef>
                        Side<i class="fa fa-sort ms-1"></i>
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
                        {{ element.leftOrRight }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="nameVariationCount">
                      <th mat-header-cell (click)="sortTable('nameVariationCount')"
                        class="name-variation-heading w-6-rem" *matHeaderCellDef>
                        Variations<i class="fa fa-sort ms-1"></i>
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [class.moved]="i === newLocation"
                        class="ps-4">
                        {{ element.nameVariationCount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="moveup">
                      <th mat-header-cell class="category-heading w-3-rem" *matHeaderCellDef>
                        Move Up
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
                        <span role="button">
                          <i class="fa fa-arrow-up" (click)="moveItem($event, i, i - 1)"></i>
                        </span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="movedown">
                      <th mat-header-cell class="category-heading w-3-rem" *matHeaderCellDef>
                        Move Down
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" [class.moved]="i === newLocation">
                        <span role="button">
                          <i class="fa fa-arrow-down" (click)="moveItem($event, i, i + 1)"></i>
                        </span>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns$.value"></tr>
                    <tr mat-row *matRowDef="
                        let row;
                        columns: displayedColumns$.value;
                        let vetUserIndex = index
                      " class="border-start-0 border-end-0 pointer pt-2" cdkDrag></tr>
                  </table>
                  <!--<div class="col-md-12 text-center" *ngIf="isLoader">
                    Loading <i class="fa fa-spinner fa-spin"></i>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
